"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = void 0;
exports.Region = {
    Us: "us",
    Eu: "eu",
    Sg: "sg",
    De: "de",
    Au: "au",
    Br: "br",
    Nl: "nl",
    Fr: "fr",
    Ca: "ca",
};
